/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { addToListModalStyles } from "@monsma/Overrides/Components/ManageShareListModal";
import { removeLinkStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

addToListModalStyles.modal = {
    size: 600,
};

addToListModalStyles.inviteButton = {
    variant: "secondary",
    sizeVariant: "small",
    css: css`
        margin-left: 10px;

        &&& {
            width: auto;
        }
    `,
};

addToListModalStyles.userCell = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
};

addToListModalStyles.userRemoveLink = removeLinkStyle;

addToListModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    `,
};

addToListModalStyles.makePrivateButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

addToListModalStyles.closeButton = {
    variant: "primary",
};
